<template>
    <BasePage>
        <SotHeader :label="title" />
        <q-img v-if="info.transferred === '1' && !certUrl" src="~assets/ui/header-cert2-processing.png" style="padding-top: 90px;" fit="contain" />
        <q-img v-if="info.transferred === '1' && certUrl" src="~assets/ui/header-cert2-sent.png" style="padding-top: 90px;" fit="contain" />
        <div style="overflow: auto">
            <div v-if="info.transferred !== '1'" class="q-pa-md base-page-content q-gutter-y-sm">
                <div v-if="courseTitle" class="text-center text-weight-bold" style="margin-bottom: 20px">
                    {{ courseTitle }}
                </div>
                <q-file label="Скан первой страницы паспорта" class="sot-select" style="padding-left: 23px;" borderless v-model="passportFile" :display-value="passport" :loading="loadingPassport" input-style="color: #85371F" />
                <q-file label="Скан диплома" class="sot-select" borderless v-model="diplomaFile" :display-value="diploma" :loading="loadingDiploma" style="padding-bottom: 10px; padding-left: 23px;" input-style="color: #85371F" />
                <q-select ref="eduLevel" class="sot-select" borderless label="Уровень образования" :options="['СПО', 'ВО']" v-model="info.eduLevel" style="padding-left: 23px; color: #85371F;" input-style="color: #85371F" />
                <TextInput ref="profName" label="Наименование квалификации, профессии" v-model="info.profName" />
                <TextInput ref="diplomFio" label="Фамилия указанная в дипломе" v-model="info.diplomFio" />
                <TextInput ref="docSerial" label="Серия документа о ВО/СПО" v-model="info.docSerial" />
                <TextInput ref="docNum" label="Номер документа о ВО/СПО" v-model="info.docNum" />
                <TextInput ref="fioDat" label="Фамилия в дательном падеже" v-model="info.fioDat" />
                <TextInput ref="nameDat" label="Имя в дательном падеже" v-model="info.nameDat" />
                <TextInput ref="patrnameDat" label="Отчество в дательном падеже" v-model="info.patrnameDat" />
                <TextInput ref="birthday" label="Дата рождения получателя (дд.мм.гггг)" v-model="info.birthday" mask="##.##.####" />
                <q-select ref="gender" class="sot-select" borderless label="Пол получателя" :options="['мужской', 'женский']" v-model="info.gender" style="padding-left: 23px; color: #85371F;" input-style="color: #85371F" />
                <TextInput ref="snils" label="СНИЛС" v-model="info.snils" mask="###-###-### ##" />
                <TextInput ref="postIndex" label="Почтовый индекс" v-model="info.postIndex" mask="######" />
                <TextInput ref="postAddress" label="Почтовый адрес" v-model="info.postAddress" autogrow type="textarea" />
            </div>
            <div class="q-gutter-y-md q-pa-sm">
                <div v-show="commentPassport && !certUrl" class="text-caption">
                    Ответ оператора для паспорта: {{ commentPassport }}
                </div>
                <div v-show="commentDiploma && !certUrl" class="text-caption">
                    Ответ оператора для диплома: {{ commentDiploma }}
                </div>
                <div v-show="info.trackingNumber" class="text-caption text-center">
                    <div>Номер отправления:</div>
                    <strong>{{ info.trackingNumber }}</strong>
                </div>
            </div>
            <div style="padding-top: 5px; padding-bottom: 20px" class="q-gutter-y-sm q-pa-md text-center">
                <!--<DefaultButton v-show="info.transferred === '1'" label="Отправить данные повторно" @click="doRepeat" />-->
                <DefaultButton v-show="info.transferred !== '1'" label="Передать оператору" @click="doProcess" :loading="loading" />
                <DefaultButton v-show="certUrl" label="Скачать удостоверение" @click="get" :loading="loading" />
                <div v-show="info.transferred === '1'" style="margin-bottom: 20px; margin-top: 20px;">
                    <a href="#" @click.stop.prevent="doRepeat">Отправить данные повторно</a>
                </div>
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import SotHeader from 'components/ui/design/SotHeader';
import DefaultButton from 'components/ui/common/DefaultButton';
import { queryBot, sendTelegramMessage, uploadFile } from 'boot/axios';
import TextInput from 'components/ui/common/TextInput';
import unescapeSql from 'src/model/db/utils';
import uiControlMixin from 'src/mixins/ui/uiControlMixin';

// import unescapeSql from 'src/model/db/utils';

export default {
    name: 'PageCertificate2',
    components: {
        TextInput,
        DefaultButton,
        SotHeader,
        BasePage,
    },
    mixins: [uiControlMixin],
    computed: {
        title () {
            const { title } = this.params.params;
            return `Удостоверение по курсу "${title}"`;
        },
        allowGet () {
            if (this.passport) {
                const num = this.passport.replace(/[^0-9.]/g, '');
                if (num.length !== 10) {
                    return false;
                }
            }
            if (this.diploma) {
                return this.diploma.length >= 10;
            }
            return this.passport && this.diploma;
        },
    },
    beforeUnmount () {
        this.saveInfo();
    },
    watch: {
        passportFile (v) {
            if (!v) { this.passport = undefined; }
            this.loadingPassport = true;
            this.passport = v.name;
            this.uploadAttachment('passport', v);
        },
        diplomaFile (v) {
            if (!v) { this.diploma = undefined; }
            this.loadingDiploma = true;
            this.diploma = v.name;
            this.uploadAttachment('diploma', v);
        },
    },
    mounted () {
        this.init();
    },
    data () {
        return {
            passport: undefined,
            diploma: undefined,
            passportFile: undefined,
            diplomaFile: undefined,
            loading: false,
            loadingPassport: false,
            loadingDiploma: false,
            commentPassport: undefined,
            commentDiploma: undefined,
            certUrl: undefined,
            courseId: undefined,
            courseTitle: undefined,
            info: {
                eduLevel: undefined,
                profName: undefined,
                diplomFio: undefined,
                docSerial: undefined,
                docNum: undefined,
                fioDat: undefined,
                nameDat: undefined,
                patrnameDat: undefined,
                birthday: undefined,
                gender: undefined,
                snils: undefined,
                postIndex: undefined,
                postAddress: undefined,
                transferred: undefined,
                trackingNumber: undefined,
            },
        };
    },
    methods: {
        init () {
            this.courseId = this.params.params.course_id;
            this.courseTitle = this.params.params.title;
            const { user } = this.$store.state.pages;
            this.loadingPassport = true;
            this.loadingDiploma = true;
            queryBot(`select type, filename, url, comment from user_attachments where user_id = ${user.id}`).then((r) => {
                this.loadingPassport = false;
                this.loadingDiploma = false;
                for (let i = 0; i < r.data.length; i += 1) {
                    if (r.data[i].type === 'passport') {
                        this.passport = r.data[i].filename;
                        this.commentPassport = r.data[i].comment;
                    }
                    if (r.data[i].type === 'diploma') {
                        this.diploma = r.data[i].filename;
                        this.commentDiploma = r.data[i].comment;
                    }
                }
            });
            queryBot(`select cert_url from user_cert2 where user_id = ${user.id} and course_id = ${this.courseId}`).then((r) => {
                const row = r.data[0];
                if (row) {
                    this.certUrl = row.cert_url;
                }
            });
            this.loadInfo();
        },
        loadInfo () {
            const { user } = this.$store.state.pages;
            queryBot(`select id, type, value from user_info where user_id = ${user.id}`).then((r) => {
                for (let i = 0; i < r.data.length; i += 1) {
                    const row = r.data[i];
                    if (row.type === 'eduLevel') {
                        this.info.eduLevel = row.value;
                    }
                    if (row.type === 'profName') { this.info.profName = row.value; }
                    if (row.type === 'diplomFio') { this.info.diplomFio = row.value; }
                    if (row.type === 'docSerial') { this.info.docSerial = row.value; }
                    if (row.type === 'docNum') { this.info.docNum = row.value; }
                    if (row.type === 'fioDat') { this.info.fioDat = row.value; }
                    if (row.type === 'nameDat') { this.info.nameDat = row.value; }
                    if (row.type === 'patrnameDat') { this.info.patrnameDat = row.value; }
                    if (row.type === 'birthday') { this.info.birthday = row.value; }
                    if (row.type === 'gender') { this.info.gender = row.value; }
                    if (row.type === 'snils') { this.info.snils = row.value; }
                    if (row.type === 'postIndex') { this.info.postIndex = row.value; }
                    if (row.type === 'postAddress') { this.info.postAddress = row.value; }
                    if (row.type === `transferred-${this.courseId}`) { this.info.transferred = row.value; }
                    if (row.type === `trackingNumber-${this.courseId}`) { this.info.trackingNumber = row.value; }
                }
            });
        },
        saveInfo () {
            this.saveInfoField('eduLevel', this.info.eduLevel);
            this.saveInfoField('profName', this.info.profName);
            this.saveInfoField('diplomFio', this.info.diplomFio);
            this.saveInfoField('docSerial', this.info.docSerial);
            this.saveInfoField('docNum', this.info.docNum);
            this.saveInfoField('fioDat', this.info.fioDat);
            this.saveInfoField('nameDat', this.info.nameDat);
            this.saveInfoField('patrnameDat', this.info.patrnameDat);
            this.saveInfoField('birthday', this.info.birthday);
            this.saveInfoField('gender', this.info.gender);
            this.saveInfoField('snils', this.info.snils);
            this.saveInfoField('postIndex', this.info.postIndex);
            this.saveInfoField('postAddress', this.info.postAddress);
            // this.$q.notify('Сохранено');
        },
        saveInfoField (type, value) {
            const { user } = this.$store.state.pages;
            if (!value) { value = ''; }
            value = unescapeSql(value);
            queryBot(`insert into user_info (user_id, type, value) values (${user.id}, '${type}', '${value}') `
                + ` on duplicate key update value = '${value}'`);
        },
        get () {
            window.open(this.certUrl, '_blank');
        },
        uploadAttachment (type, file) {
            const { user } = this.$store.state.pages;
            uploadFile(file, this).then((url) => {
                queryBot(`insert into user_attachments (user_id, type, filename, url) values (${user.id}, '${type}', '${file.name}', '${url}') `
                    + ` on duplicate key update filename = '${file.name}', url = '${url}'`).then(() => {
                    if (type === 'passport') {
                        this.loadingPassport = false;
                    }
                    if (type === 'diploma') {
                        this.loadingDiploma = false;
                    }
                });
            });
        },
        async doProcess () {
            this.saveInfo();
            if (!this.passport) {
                this.$q.notify('Прикрепите скан паспорта');
                return;
            }
            if (!this.diploma) {
                this.$q.notify('Прикрепите скан диплома');
                return;
            }
            if (!this.info.eduLevel) {
                this.$q.notify('Укажите уровень образования');
                this.$refs.eduLevel.select();
                return;
            }
            if (!this.info.profName) {
                this.$q.notify('Укажите наименование квалификации');
                this.$refs.profName.select();
                return;
            }
            if (!this.info.diplomFio) {
                this.$q.notify('Укажите фамилия указанную в дипломе');
                this.$refs.diplomFio.select();
                return;
            }
            if (!this.info.docSerial) {
                this.$q.notify('Укажите серию документа о ВО/СПО');
                this.$refs.docSerial.select();
                return;
            }
            if (!this.info.docNum) {
                this.$q.notify('Укажите номер документа о ВО/СПО');
                this.$refs.docNum.select();
                return;
            }
            if (!this.info.fioDat) {
                this.$q.notify('Укажите фамилию в дательном падеже');
                this.$refs.fioDat.select();
                return;
            }
            if (!this.info.nameDat) {
                this.$q.notify('Укажите имя в дательном падеже');
                this.$refs.nameDat.select();
                return;
            }
            if (!this.info.patrnameDat) {
                this.$q.notify('Укажите отчество в дательном падеже');
                this.$refs.patrnameDat.select();
                return;
            }
            if (!this.info.birthday || (this.info.birthday && this.info.birthday.length !== 10)) {
                this.$q.notify('Укажите корректную дату рождения');
                this.$refs.birthday.select();
                return;
            }
            if (!this.info.gender) {
                this.$q.notify('Укажите пол');
                this.$refs.gender.select();
                return;
            }
            if (!this.info.snils) {
                this.$q.notify('Укажите СНИЛС');
                this.$refs.snils.select();
                return;
            }
            if (!this.info.postIndex) {
                this.$q.notify('Укажите почтовый индекс');
                this.$refs.postIndex.select();
                return;
            }
            if (!this.info.postAddress) {
                this.$q.notify('Укажите почтовый адрес');
                this.$refs.postAddress.select();
                return;
            }
            if (this.info.transferred === '1') {
                // this.$q.notify('Вы уже отправляли данные на обработку, дождитесь ответа оператора');
                return;
            }
            this.$q.notify('Передано в обработку');
            this.saveInfoField(`transferred-${this.courseId}`, '1');
            this.info.transferred = '1';

            const { user } = this.$store.state.pages;
            const msg = `Спасибо, Ваши данные для удостоверения по курсу "${this.courseTitle}" получены и находятся на проверке, мы постараемся обработать их в течение суток`;
            sendTelegramMessage(user.chat_id, msg);

            const getCourseTitle = () => new Promise((resolve) => {
                queryBot(`select title from courses where id = '${this.courseId}'`).then((r) => {
                    if (r.data[0]) {
                        resolve(r.data[0].title);
                    } else {
                        resolve(undefined);
                    }
                });
            });

            let courseTitle;
            await getCourseTitle().then((title) => {
                courseTitle = title;
            });

            this.$db.users.sendChatQuestion(user.chat_id, 0, `Отправлены документы для создания удостоверения по курсу ${courseTitle}`);
        },
        doRepeat () {
            this.info.transferred = '0';
            // this.saveInfoField('transferred', '0');
        },
    },
};
</script>

<style scoped>

</style>
